import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { triggerEnsightenEvent } from '../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_APP_APPROVED } from '../../../framework/store/Ensighten/EnsightenConstants';
import { REDIRECT_SUFFIX } from '../../../framework/App/AppConstants';
import RedirectButton from '../../../shared-components/RedirectButton/RedirectButton';

const LOCALE_PREFIX = 'GB/pages/DecisionPage/DecisionApproved';


export class DecisionApproved extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        const {
            intl
        } = this.props;

        const buttonLabel = intl.formatMessage({id:`${LOCALE_PREFIX}.approved.buttonLabel`});
        return (
            <div id="DecisionApproved">
                <section id="approved" className="contentSection">
                    <div className="row-fluid container">
                        <span className="span24">
                            <div className="approved-check success-image" />
                            <h2 className="alpha approve-header">
                                <FormattedHTMLMessage id={`${LOCALE_PREFIX}.approved.header`} />
                            </h2>
                            <div className="tesla-approve-messages">
                                <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.approved.primary`} /></p>
                            </div>
                            <div className="row-fluid">
                                <span className="span14">
                                    <div className="buttons">
                                        <RedirectButton
                                            ctaLabel={buttonLabel}
                                            className="decisionReturnFlowAction approve-continue-button"
                                            buttonId="declinedContinue"
                                            actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
                                        />
                                    </div>
                                </span>
                            </div>

                        </span>
                    </div>
                </section>
            </div>

        );
    }
}

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_APPROVED));
    }
});

export default connect(null, mapDispatchToProps)(injectIntl(DecisionApproved));